import { Skeleton } from '@neutrino/ui'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { ProfileDropdown } from '@/components/profile-dropdown'
import { Search } from '@/components/search'
import { ThemeSwitch } from '@/components/theme-switch'

/**
 * Loading fallback for lazy-loaded features
 * Provides a skeleton UI that matches the typical feature layout
 */
export default function FeatureLoading() {
  return (
    <>
      <Header>
        <Search />
        <div className='ml-auto flex items-center space-x-4'>
          <ThemeSwitch />
          <ProfileDropdown />
        </div>
      </Header>

      <Main>
        <div className='flex flex-col gap-6'>
          {/* Page title skeleton */}
          <div>
            <Skeleton className='mb-2 h-8 w-48' />
            <Skeleton className='h-4 w-96' />
          </div>

          {/* Main content grid skeleton */}
          <div className='grid gap-6 lg:grid-cols-3'>
            {/* Sidebar/summary skeleton */}
            <div className='space-y-4 lg:col-span-1'>
              <div className='rounded-lg border bg-white p-6'>
                <Skeleton className='mb-4 h-6 w-32' />
                <div className='space-y-3'>
                  <div className='flex justify-between'>
                    <Skeleton className='h-4 w-24' />
                    <Skeleton className='h-4 w-16' />
                  </div>
                  <div className='flex justify-between'>
                    <Skeleton className='h-4 w-28' />
                    <Skeleton className='h-4 w-20' />
                  </div>
                  <div className='flex justify-between'>
                    <Skeleton className='h-4 w-20' />
                    <Skeleton className='h-4 w-12' />
                  </div>
                </div>
              </div>
            </div>

            {/* Main content skeleton */}
            <div className='space-y-6 lg:col-span-2'>
              {/* Card skeleton */}
              <div className='rounded-lg border bg-white p-6'>
                <div className='mb-4 flex items-center justify-between'>
                  <Skeleton className='h-6 w-40' />
                  <Skeleton className='h-8 w-20' />
                </div>
                <div className='space-y-4'>
                  <Skeleton className='h-4 w-full' />
                  <Skeleton className='h-4 w-3/4' />
                  <Skeleton className='h-4 w-1/2' />
                </div>
              </div>

              {/* Another card skeleton */}
              <div className='rounded-lg border bg-white p-6'>
                <Skeleton className='mb-4 h-6 w-32' />
                <div className='grid gap-4 md:grid-cols-2'>
                  <div className='space-y-2'>
                    <Skeleton className='h-4 w-20' />
                    <Skeleton className='h-8 w-full' />
                  </div>
                  <div className='space-y-2'>
                    <Skeleton className='h-4 w-24' />
                    <Skeleton className='h-8 w-full' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Main>
    </>
  )
}
